"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Meta;
var _reactHelmetAsync = require("react-helmet-async");
var _reactRouter = require("react-router");
var _env = require("../utils/env");
var _jsxRuntime = require("react/jsx-runtime");
function Meta(props) {
  var _useLocation = (0, _reactRouter.useLocation)(),
    pathname = _useLocation.pathname;
  function renderCanonical() {
    // Static generation will result in a location of /*
    // for catch all routes which should be assumed to be
    // 404 pages and should not return a canonical tag.
    if (pathname !== '/*') {
      var href = "".concat(_env.LANDING_URL).concat(pathname);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
        rel: "canonical",
        href: href
      });
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHelmetAsync.Helmet, {
    children: [renderCanonical(), props.children]
  });
}